<section class="" id="reservation-confirmation">
    <div #scrollToPrintsection class="container confirmation print-section" *ngIf="!showReservationFailure">
        <h1 class="confirmation__page-title">{{langDictionary.CONFIRMATION.Thanks}}</h1>
        <span class="confirmation__lead">{{langDictionary.CONFIRMATION.Registered_For}}</span>
        <h3 class="confirmation__event-title" *ngIf="isHavingTitles">{{eventTitle}}</h3>
        <ng-container *ngIf="multiEvent; else notMultiEvent">
           <section class="eventcardwrapper" [class.apply-last-style]="faliureEvents && faliureEvents.length">
            <div class="eventCard" *ngFor="let event of events">
                <div class="eventCard__titlevenue" *ngIf="!isHavingTitles">{{event.titleVenue}}</div>
                <div class="eventCard__eventInfo">
                    <div class="eventCard__timeLocation">
                        <div class="eventCard__timeLocation--mediumtxt">{{event?.eventDay}}, {{event?.eventMonth}} {{event?.day}} @ {{event?.time}}</div>
                        <div class="eventCard__timeLocation--address">
                            <div>{{event.name}}</div>
                            <div>{{event.eventAddress.AddressLine1}}</div>
                            <div>
                                {{event.eventAddress?.City}}, {{event.eventAddress?.State}} {{event.eventAddress?.Zip}}
                            </div>
                        </div>
                    </div>
                    <div class="eventCard__eventwidget">
                        <span class="confirmation__notice print-none eventwidget__confirm">{{langDictionary.CONFIRMATION.Click_Calendar}}</span>
                        <div class="calender-event print-none eventwidget__wrap">
                            <section #calendarClick class="event eventwidget__outer" (click)="multiToggleDropdown(event, $event)">
                                <div class="event__date-box">
                                    <div class="event__date">
                                        <span class="event__month">{{event?.monthAbbr}}</span>
                                    </div>
                                    <span class="event__date-of-month">{{event?.day}}</span>
                                </div>
                                <div class="event__details">
                                    <div class="event__title">{{event.titleVenue}}</div>
                                    <div class="event__venue">
                                        <span>{{langDictionary.CONFIRMATION.Location}}</span> <span class="px-1">{{event?.name}}</span>
                                    </div>
                                    <div class="event__info">
                                        <span>{{langDictionary.CONFIRMATION.When}}</span>
                                        <span class="px-1">{{event?.time}}</span>
                                    </div>
                                </div>
                    
                            </section>                            
                            <app-add-to-calendar [multi]="true" [event]="event.calendarEvent" [isOpen]="event.calendarIsopen">
                            </app-add-to-calendar>
                        </div>
                    </div>
                </div>
                
            </div>
            <section class="faliureEventswrap"  *ngIf="faliureEvents && faliureEvents.length">
                <div class="faliureEventsHead">We are unable to register you for the following events:</div>
                <div class="faliureEventsList">
                    <div class="faliureEvents" *ngFor="let failEvent of faliureEvents">
                    <section class="faliureEvent">
                        <div>
                            <span>{{failEvent.titleVenue}} - </span>
                            <span>{{failEvent?.eventDay}}, {{failEvent?.eventMonth}} {{failEvent?.day}} @
                                {{failEvent?.time}}</span>
                        </div>                        
                    </section>
                </div>
                </div>
                
                <div class="faliureEventsFooter">For questions or to update your reservation(s) please call {{phone}}</div>
            </section>
            
           </section>
        </ng-container>
        <ng-template #notMultiEvent>
            <h3 class="confirmation__event-title">{{eventTitle}}</h3>
            <h2 class="confirmation__date-time">{{eventDay}}, {{eventMonth}} {{event?.day}} @ <br>{{event?.time}}</h2>
            <hr class="confirmation__custom-hr">
            <p>{{event?.Name}}<br>
                {{eventAddress?.AddressLine1}}<br>
                {{eventAddress?.AddressLine2}} <br *ngIf="eventAddress.AddressLine2">
                {{eventAddress?.City}}, {{eventAddress?.State}} {{eventAddress?.Zip}}
            </p>
            <span *ngIf="confirmationDisclaimer" class="confirmation__disclaimer-txt"><i>{{confirmationDisclaimer}}</i></span>
            <span class="confirmation__notice print-none">{{langDictionary.CONFIRMATION.Click_Calendar}}</span>
            <div class="calender-event print-none">
                <section #calendarClick class="event" (click)="toggleDropdown($event)">
                    <div class="event__date-box">
                        <div class="event__date">
                            <span class="event__month">{{event?.monthAbbreviation}}</span>
                        </div>
                        <span class="event__date-of-month">{{event?.day}}</span>
                    </div>
                    <div class="event__details">
                        <div class="event__title">{{eventTitle}}</div>
                        <div class="event__venue">
                            <span>{{langDictionary.CONFIRMATION.Location}}</span> <span class="px-1">{{event?.Name}}</span>
                        </div>
                        <div class="event__info">
                            <span>{{langDictionary.CONFIRMATION.When}}</span>
                            <span class="px-1">{{event?.time}}</span>
                        </div>
                    </div>
        
                </section>
                <div *ngIf="showFinraDisclosure" class="finraText" [innerHTML]="finraDisclosure"></div>
                <app-add-to-calendar [event]="calendarEvent" [isOpen]="isOpen">
                </app-add-to-calendar>
            </div>
        </ng-template>

        <span *ngIf="multiEvent && confirmationDisclaimer" class="confirmation__disclaimer-txt multievent-disclaimer"><i>{{confirmationDisclaimer}}</i></span>
        <div *ngIf="multiEvent && showFinraDisclosure" class="finraText multievent-finra" [innerHTML]="finraDisclosure"></div>
        <button class="button button--primary hero__button w-50 print-none" (click)="print()">{{langDictionary.CONFIRMATION.Print_Confirmation}}</button>


    </div>
    <div class="non-confirmation" *ngIf="showReservationFailure">
           <h1 class="confirmation__page-title">{{langDictionary.NON_CONFIRMATION.Sorry}}</h1>
        <span class="confirmation__lead">{{langDictionary.NON_CONFIRMATION.Not_Qualify}}</span>
    </div>
</section>

<hr class="d-none">
